import { useEffect } from "react";
import Lenis from "lenis";

const TOP_SCROLL_RAMP = 180;
const MIN_TOP_WHEEL_SCALE = 0.45;

const softenTopWheelInput = (input) => {
  const progress = Math.min(Math.max(window.scrollY, 0) / TOP_SCROLL_RAMP, 1);
  const scale = MIN_TOP_WHEEL_SCALE + (1 - MIN_TOP_WHEEL_SCALE) * progress;
  input.deltaY *= scale;
};

const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({
      autoRaf: true,
      duration: 1.4,
      easing: (t) => Math.min(1, 1.001 - 2 ** (-10 * t)),
      smoothWheel: true,
      virtualScroll: softenTopWheelInput,
    });

    window.__lenis = lenis;

    return () => {
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return null;
};

export default SmoothScroll;
